<template>
  <div>
    <div @click="refreshCode">
      <Sidentify :identifyCode="identifyCode"></Sidentify>
    </div>
  </div>
</template>

<script>
import Sidentify from "../identify";
export default {
  components: { Sidentify },
  data() {
    return {
      identifyCodes: "1234567890abcdef",
      identifyCode: "",
    };
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  created() {},
  methods: {
    // 验证码处理
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    // 刷新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
      console.log(this.identifyCode);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/TEST/TEST.vue